export default "__VITE_ASSET__Cgj7qZ3w__"